module.exports = __webpack_public_path__ + "media/fr_ca_s2_Fabien.b7a891e7.oga";